module.exports = __webpack_public_path__ + "img/AT0000002611737.c50d04f4.png";